var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(88.627451%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(88.627451%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 274.108008 35.495068 L 174.597363 109.389111 L 193.006055 65.80459 Z M 274.108008 35.495068 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 44.388281 35.495068 L 143.095166 110.08916 L 125.593945 65.80459 Z M 44.388281 35.495068 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 238.301807 206.799609 L 211.803662 247.402441 L 268.507617 263.010938 L 284.790234 207.70708 Z M 238.301807 206.799609 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 33.887549 207.70708 L 50.092383 263.010938 L 106.796338 247.402441 L 80.298193 206.799609 Z M 33.887549 207.70708 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 103.607227 138.194824 L 87.791309 162.100195 L 144.106348 164.589258 L 142.109912 104.099854 Z M 103.607227 138.194824 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 214.889062 138.194824 L 175.89375 103.399805 L 174.597363 164.589258 L 230.808691 162.100195 Z M 214.889062 138.194824 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 106.796338 247.402441 L 140.606104 230.912402 L 111.411475 208.095996 Z M 106.796338 247.402441 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,46.27451%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,46.27451%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 177.890186 230.912402 L 211.803662 247.402441 L 207.110742 208.095996 Z M 177.890186 230.912402 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(84.313725%,75.686275%,70.196078%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(84.313725%,75.686275%,70.196078%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 211.803662 247.402441 L 177.890186 230.912402 L 180.612598 253.002832 L 180.301465 262.310889 Z M 211.803662 247.402441 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(84.313725%,75.686275%,70.196078%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(84.313725%,75.686275%,70.196078%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 106.796338 247.402441 L 138.298535 262.310889 L 138.091113 253.002832 L 140.606104 230.912402 Z M 106.796338 247.402441 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(13.72549%,20.392157%,27.843137%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,20.392157%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 138.791162 193.498682 L 110.607715 185.201807 L 130.494287 176.101172 Z M 138.791162 193.498682 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(13.72549%,20.392157%,27.843137%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(13.72549%,20.392157%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 179.705127 193.498682 L 188.002002 176.101172 L 207.992285 185.201807 Z M 179.705127 193.498682 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(80.392157%,38.039216%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.392157%,38.039216%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 106.796338 247.402441 L 111.592969 206.799609 L 80.298193 207.70708 Z M 106.796338 247.402441 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(80.392157%,38.039216%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.392157%,38.039216%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 207.007031 206.799609 L 211.803662 247.402441 L 238.301807 207.70708 Z M 207.007031 206.799609 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(80.392157%,38.039216%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.392157%,38.039216%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 230.808691 162.100195 L 174.597363 164.589258 L 179.808838 193.498682 L 188.105713 176.101172 L 208.095996 185.201807 Z M 230.808691 162.100195 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(80.392157%,38.039216%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(80.392157%,38.039216%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.607715 185.201807 L 130.597998 176.101172 L 138.791162 193.498682 L 144.106348 164.589258 L 87.791309 162.100195 Z M 110.607715 185.201807 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,45.882353%,12.156863%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,45.882353%,12.156863%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 87.791309 162.100195 L 111.411475 208.095996 L 110.607715 185.201807 Z M 87.791309 162.100195 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,45.882353%,12.156863%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,45.882353%,12.156863%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 208.095996 185.201807 L 207.110742 208.095996 L 230.808691 162.100195 Z M 208.095996 185.201807 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,45.882353%,12.156863%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,45.882353%,12.156863%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 144.106348 164.589258 L 138.791162 193.498682 L 145.402734 227.593652 L 146.906543 182.712744 Z M 144.106348 164.589258 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(89.411765%,45.882353%,12.156863%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(89.411765%,45.882353%,12.156863%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 174.597363 164.589258 L 171.900879 182.609033 L 173.093555 227.593652 L 179.808838 193.498682 Z M 174.597363 164.589258 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 179.808838 193.498682 L 173.093555 227.593652 L 177.890186 230.912402 L 207.110742 208.095996 L 208.095996 185.201807 Z M 179.808838 193.498682 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.607715 185.201807 L 111.411475 208.095996 L 140.606104 230.912402 L 145.402734 227.593652 L 138.791162 193.498682 Z M 110.607715 185.201807 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(75.294118%,67.843137%,61.960784%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(75.294118%,67.843137%,61.960784%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 180.301465 262.310889 L 180.612598 253.002832 L 178.097607 250.798975 L 140.398682 250.798975 L 138.091113 253.002832 L 138.298535 262.310889 L 106.796338 247.402441 L 117.789697 256.399365 L 140.087549 271.90415 L 178.40874 271.90415 L 200.810303 256.399365 L 211.803662 247.402441 Z M 180.301465 262.310889 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(8.627451%,8.627451%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(8.627451%,8.627451%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 177.890186 230.912402 L 173.093555 227.593652 L 145.402734 227.593652 L 140.606104 230.912402 L 138.091113 253.002832 L 140.398682 250.798975 L 178.097607 250.798975 L 180.612598 253.002832 Z M 177.890186 230.912402 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(46.27451%,23.921569%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(46.27451%,23.921569%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 278.308301 114.21167 L 286.812598 73.401416 L 274.108008 35.495068 L 177.890186 106.900049 L 214.889062 138.194824 L 267.21123 153.492188 L 278.800928 140.009766 L 273.796875 136.405811 L 281.808545 129.094189 L 275.611816 124.297559 L 283.597559 118.204541 Z M 278.308301 114.21167 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(46.27451%,23.921569%,8.627451%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(46.27451%,23.921569%,8.627451%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 31.787402 73.401416 L 40.291699 114.21167 L 34.89873 118.204541 L 42.9104 124.297559 L 36.791455 129.094189 L 44.803125 136.405811 L 39.799072 140.009766 L 51.310986 153.492188 L 103.607227 138.194824 L 140.606104 106.900049 L 44.388281 35.495068 Z M 31.787402 73.401416 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 267.21123 153.492188 L 214.889062 138.194824 L 230.808691 162.100195 L 207.110742 208.095996 L 238.301807 207.70708 L 284.790234 207.70708 Z M 267.21123 153.492188 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 103.607227 138.194824 L 51.310986 153.492188 L 33.887549 207.70708 L 80.298193 207.70708 L 111.411475 208.095996 L 87.791309 162.100195 Z M 103.607227 138.194824 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.470588%,52.156863%,10.588235%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(96.470588%,52.156863%,10.588235%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 174.597363 164.589258 L 177.890186 106.900049 L 193.109766 65.80459 L 125.593945 65.80459 L 140.606104 106.900049 L 144.106348 164.589258 L 145.299023 182.790527 L 145.402734 227.593652 L 173.093555 227.593652 L 173.300977 182.790527 Z M 174.597363 164.589258 ",
    transform: "matrix(0.150659,0,0,0.150659,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.1ecfa934.svg";
export { ForwardRef as ReactComponent };